import { render, staticRenderFns } from "./SanteTns.vue?vue&type=template&id=0a96fd42&scoped=true&"
import script from "./SanteTns.vue?vue&type=script&lang=js&"
export * from "./SanteTns.vue?vue&type=script&lang=js&"
import style0 from "./SanteTns.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SanteTns.vue?vue&type=style&index=1&id=0a96fd42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a96fd42",
  null
  
)

export default component.exports